import React from "react";
import Footerbg from "../images/footer-bg.svg";
import { IconChevronRight } from "@tabler/icons-react";
import { IconBrandLinkedin } from "@tabler/icons-react";
import { IconBrandInstagram } from "@tabler/icons-react";
import xcardbg from "../images/stay-informed-card-bg.svg";
import { IconBrandFacebook } from "@tabler/icons-react";
import stay from "../images/bg-image-card.svg";
import discord from "../images/discord-card-bg.svg";
import gitcard from "../images/git-card-bg.svg";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();

  return (
    <>
      <section
        style={{
          backgroundImage: `url(${Footerbg})`,
          backgroundPosition: "50% 0",
        }}
        className="bg-no-repeat bg-cover max-w-none lg:py-16 py-10 relative">
        {pathname === "/" && (
          <div className="container lg:pb-40 lg:pt-16 py-10 lg:px-10 px-6 max-w-[1600px] mx-auto">
            <div className="space-y-8">
              <div className="space-y-2">
                <h2 className="text-white text-center lg:text-4xl text-3xl font-medium ">
                  Looking for custom solutions?
                </h2>
                <p className="text-[rgb(171,174,187)] text-center text-base font-medium lg:w-[40%] mx-auto">
                  Our engineers, backed by over 30 years of experience, offer
                  free consultation and custom design services to meet your
                  specific needs.
                </p>
              </div>
              <div className="text-center justify-center sm:flex gap-6 sm:space-y-0 space-y-5">
                <a
                  href="/contact"
                  className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative">
                  <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                  <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                  <span className="absolute inset-0 rounded-full bg-black"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                  <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                    Book a consultation
                  </span>
                </a>
                <a href="/contact" className="group text-base font-medium text-white flex gap-1 items-center sm:m-0 mx-auto hover:text-[#fcc171] transition-colors duration-200">
                  Let's Build Together
                  <IconChevronRight
                    size={20}
                    stroke={2}
                    className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                  />
                </a>
              </div>
            </div>
          </div>
        )}

        {pathname === "/solutions" && (
          <div className="container lg:pb-40 lg:pt-16 py-10 lg:px-10 px-6 max-w-[1600px] mx-auto">
            <div className="space-y-8">
              <div className="space-y-2">
                <h2 className="text-white text-center lg:text-4xl text-3xl font-medium ">
                  Discuss your precision engineering needs{" "}
                </h2>
                <p className="text-[rgb(171,174,187)] text-center text-base font-medium lg:w-[40%] mx-auto">
                  Let’s explore how advanced manufacturing solutions can help
                  you accelerate production, improve quality, and achieve your
                  business goals.
                </p>
              </div>
              <div className="text-center justify-center sm:flex gap-6 sm:space-y-0 space-y-5">
                <a
                  href="/contact"
                  className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative">
                  <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                  <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                  <span className="absolute inset-0 rounded-full bg-black"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                  <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                    Book a consultation
                  </span>
                </a>
                <a href="/contact" className="group text-base font-medium text-white flex gap-1 items-center sm:m-0 mx-auto hover:text-[#fcc171] transition-colors duration-200">
                  Let's Build with Precision
                  <IconChevronRight
                    size={20}
                    stroke={2}
                    className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                  />
                </a>
              </div>
            </div>
          </div>
        )}

        {(pathname === "/blog" || pathname.startsWith("/blog/")) && (
          <div className="container lg:pb-40 lg:pt-16 py-10 lg:px-10 px-6 max-w-[1600px] mx-auto">
            <div className="space-y-8">
              <div className="space-y-2">
                <h2 className="text-white text-center lg:text-4xl text-3xl font-medium">
                  Stay updated with industry insights
                </h2>
                <p className="text-[rgb(171,174,187)] text-center text-base font-medium lg:w-[40%] mx-auto">
                  Get the latest news on precision engineering, manufacturing
                  technology, and industry best practices.
                </p>
              </div>
              <div className="text-center justify-center sm:flex gap-6 sm:space-y-0 space-y-5">
                <a
                  href="/contact"
                  className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative">
                  <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                  <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                  <span className="absolute inset-0 rounded-full bg-black"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                  <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                  <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                    Get a Free Quote
                  </span>
                </a>
                <a href="/solutions" className="group text-base font-medium text-white flex gap-1 items-center sm:m-0 mx-auto hover:text-[#fcc171] transition-colors duration-200">
                  Explore Our Solutions
                  <IconChevronRight
                    size={20}
                    stroke={2}
                    className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                  />
                </a>
              </div>
            </div>
          </div>
        )}

        {pathname === "/about-us" && (
          <div className="container lg:pb-40 lg:pt-16 py-10 lg:px-10 px-6 max-w-[1600px] mx-auto">
            <div className="space-y-8">
              <div className="space-y-2">
                <h2 className="text-white text-center lg:text-4xl text-3xl font-semibold ">
                  Join our growing team
                </h2>
                <p className="text-[rgb(171,174,187)] text-center text-base font-medium lg:w-[40%] mx-auto">
                  Obsessed with precision engineering experience? So are we.
                  Come shape the future with us.
                </p>
              </div>
              <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-6">
                <div className="relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer">
                  <img
                    alt="Contribute to open source"
                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                    loading="lazy"
                    decoding="async"
                    data-nimg="1"
                    src={xcardbg}
                    style={{ color: "transparent" }}
                  />
                  <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                    <IconBrandInstagram
                      className="text-[#fff]/70"
                      size={32}
                      stroke={1.5}
                    />
                  </div>
                  <div>
                    <h3 className="text-white text-lg font-medium flex items-center leading-[inherit]">
                      Instagram{" "}
                    </h3>
                    <p className="text-[rgb(171,174,187)] font-normal">
                      Follow us for updates, stories, and highlights.
                    </p>
                  </div>
                  <div className="">
                    <h3 className="text-white text-base font-medium leading-[inherit]">
                      {" "}
                      <a
                        href="http://instagram.com/gxl_engineering"
                        className=" flex items-center"
                        target="_blank"
                        rel="noopener noreferrer">
                        Follow us{" "}
                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                          <IconChevronRight className="" size={20} stroke={2} />
                        </span>
                      </a>
                    </h3>
                  </div>
                </div>
                <div className="relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer">
                  <img
                    alt="Contribute to open source"
                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                    loading="lazy"
                    decoding="async"
                    data-nimg="1"
                    src={stay}
                    style={{ color: "transparent" }}
                  />
                  <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                    <IconBrandFacebook
                      className="text-[#fff]/70"
                      size={32}
                      stroke={1.5}
                    />
                  </div>
                  <div>
                    <h3 className="text-white text-lg font-medium flex items-center leading-[inherit]">
                      Facebook 
                    </h3>
                    <p className="text-[rgb(171,174,187)] font-normal">
                      Join our community for news and tips.
                    </p>
                  </div>
                  <div className="">
                    <h3 className="text-white text-base font-medium leading-[inherit]">
                      {" "}
                      <a
                        href="https://www.facebook.com/profile.php?id=61555381422813"
                        className=" flex items-center"
                        target="_blank"
                        rel="noopener noreferrer">
                        Follow us{" "}
                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                          <IconChevronRight className="" size={20} stroke={2} />
                        </span>
                      </a>
                    </h3>
                  </div>
                </div>
                <div className="relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer">
                  <img
                    alt="Contribute to open source"
                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                    loading="lazy"
                    decoding="async"
                    data-nimg="1"
                    src={discord}
                    style={{ color: "transparent" }}
                  />
                  <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5  flex justify-center items-center ">
                    <IconBrandWhatsapp
                      className="text-[#fff]/70"
                      size={32}
                      stroke={1.5}
                    />
                  </div>

                  <div>
                    <h3 className="text-white text-lg font-medium flex items-center leading-[inherit]">
                      Whatsapp
                    </h3>
                    <p className="text-[rgb(171,174,187)] font-normal">
                      Get instant updates and alerts. Join us.
                    </p>
                  </div>
                  <div className="">
                    <h3 className="text-white text-base font-medium leading-[inherit]">
                      {" "}
                      <a
                        href="https://api.whatsapp.com/send/?phone=60126815982&text&type=phone_number&app_absent=0"
                        className=" flex items-center"
                        target="_blank"
                        rel="noopener noreferrer">
                        Join us{" "}
                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                          <IconChevronRight className="" size={20} stroke={2} />
                        </span>
                      </a>
                    </h3>
                  </div>
                </div>
                <div className="relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer">
                  <img
                    alt="Contribute to open source"
                    className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                    loading="lazy"
                    decoding="async"
                    data-nimg="1"
                    src={gitcard}
                    style={{ color: "transparent" }}
                  />
                  <div className="h-14 w-14 border border-[#fff]/30 rounded-full p-2.5 flex justify-center items-center ">
                    <IconBrandLinkedin
                      className="text-[#fff]/70"
                      size={32}
                      stroke={1.5}
                    />
                  </div>
                  <div>
                    <h3 className="text-white text-lg font-medium flex items-center leading-[inherit]">
                      Linkedin
                    </h3>
                    <p className="text-[rgb(171,174,187)] font-normal">
                      Follow for insights, updates, and careers.
                    </p>
                  </div>
                  <div className="">
                    <h3 className="text-white text-base font-medium leading-[inherit]">
                      {" "}
                      <a
                        href="https://www.linkedin.com/company/gxl-engineering"
                        className=" flex items-center"
                        target="_blank"
                        rel="noopener noreferrer">
                        Join us{" "}
                        <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                          <IconChevronRight className="" size={20} stroke={2} />
                        </span>
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <footer>
          <div className="container pt-10 lg:px-10 px-6 max-w-[1600px] mx-auto">
            <div className="bg-[linear-gradient(90deg,_rgba(43,47,54,0)_1.69%,_#2b2f36_20.55%,_#2b2f36_76.98%,_rgba(43,47,54,0)_95.81%)] border-t-2 border-t-gray-700 h-[1px]"></div>
            <div className="grid lg:grid-cols-2 pt-8 gap-4">
              <div>
                <h1 className="text-3xl font-semibold text-white">
                  GXL Engineering
                </h1>
                <p className="text-[rgb(171,174,187)] text-start text-base font-medium mt-2 lg:w-[70%]">
                  Delivering Innovative Engineering Solutions with Precision and
                  Integrity
                </p>
                <div className="flex gap-4 mt-5 text-[#fff]/60">
                  <a href="http://instagram.com/gxl_engineering">
                    <IconBrandInstagram
                      className="cursor-pointer"
                      size={28}
                      stroke={1.5}
                    />
                  </a>
                  <a href="https://www.linkedin.com/company/gxl-engineering">
                    <IconBrandLinkedin
                      className="cursor-pointer"
                      size={28}
                      stroke={1.5}
                    />
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61555381422813">
                    <IconBrandFacebook
                      className="cursor-pointer"
                      size={28}
                      stroke={1.5}
                    />
                  </a>
                </div>
              </div>
              <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
                <div>
                  <h4 className="text-white text-lg font-semibold">
                    Quick Links{" "}
                  </h4>
                  <ul className="text-[#fff]/60 font-light space-y-1 mt-2">
                    <li className="hover:text-white duration-300">
                      {" "}
                      <a href="/">Home </a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="/solutions">Solutions </a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="/about-us">About Us </a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="/blog">Blog </a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="/contact">Contact Us </a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-white text-lg font-semibold">
                    Contact Information
                  </h4>
                  <ul className="text-[#fff]/60 font-light space-y-2 mt-2 ">
                    <li className="hover:text-white duration-300">
                      GXL Engineering &amp; Trading Sdn Bhd
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="tel:+60126815982">012-6815982</a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="tel:+6066310984">+606-6310984 (Tel/Fax)</a>
                    </li>
                    <li className="hover:text-white duration-300">
                      <a href="mailto:sales@gxleng.com">sales@gxleng.com</a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-white text-lg font-semibold">
                    Business Hours{" "}
                  </h4>
                  <ul className="text-[#fff]/60 font-light space-y-1 mt-2">
                    <li className="hover:text-white duration-300">
                      <span>Mon – Fri: 9:00 AM – 6:00 PM </span>
                    </li>
                    <li className="hover:text-white duration-300">
                      <span>Sat – Sun: Closed </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="container lg:px-10 px-6 max-w-[1600px] mx-auto mt-8 text-center">
          <p className="text-[#fff]/80 text-sm font-semibold">
            GXL Engineering &amp; Trading Sdn Bhd
          </p>
          <p className="text-[#fff]/70 text-sm">SSM : 201001009239</p>
        </div>
        <div className="container lg:pt-16 pt-10 lg:px-10 px-6 max-w-[1600px] mx-auto ">
          <hr className="w-full h-px opacity-10 pb-4" />
          <div className="md:flex items-center justify-between md:space-y-0 space-y-2">
            <p className="text-[#fff]/70 text-base">
              Copyright © {new Date().getFullYear()} GXL Engineering. All Rights
              Reserved
            </p>
            <p className="text-[#fff]/70 text-base">
              Built on trust. Powered by innovation.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
